import { SoftwareVersionCoverageInput } from "../models/input/grahpql-software-version-coverage-input";
import { SoftwareVersionCoverageDto } from "src/app/models/dto/softwareVersionCoverageDto";

export function convertSoftwareVersionCoverageDtoToGraphqlInput(input: SoftwareVersionCoverageDto): SoftwareVersionCoverageInput {
    return {
        Uid: input.uid ?? '',
        ItemNo: input.itemNo,
        Name: input.name,
        Version: input.version,
        ModifiedBy: input.modifiedBy,
        ModificationTime: null,
        Comment: input.comment,
        LockedBy: input.lockedBy,
        LockedTime: null,
        CreatedBy: input.createdBy,
        CreationTime: null,
        ApprovalStatus: input.approvalStatus,
        ApprovedForTestLevel: input.approvedForTestLevel,
        EcuIds: input.ecuIds,
        SoftwareVersions: input.softwareVersions,
        Tags: input.tags,
    }
  }